import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { NewDialogTitle, NewDialogContent } from 'components';

export default function Loading({ onClose }) {
  return (
    <>
      {/* <NewDialogTitle title="در حال بارگذاری" onClose={onClose} />
      <NewDialogContent isPopup> */}
        <Stack height={320} p={1} flex={1} rowGap={1} bgcolor="background.paper" alignItems="center" justifyContent="center">
          <CircularProgress />
          <Typography variant="caption" color="textDisabled">در حال بارگذاری</Typography>
        </Stack>
      {/* </NewDialogContent> */}
    </>
  );
}
